export enum ContractEndOptionsView {
    OPTIONS_OVERVIEW = 'OPTIONS_OVERVIEW',
    RENEWAL_OPTIONS = 'RENEWAL_OPTIONS',
    DEALER_INFORMATION = 'DEALER_INFORMATION',
}
